import React from "react";
import kaiImg from "Assets/KAI.png";
import "./kaiAvatar.css";

export default function KaiAvatar({
  size = 28,
  className = "",
  alt = "KAI",
  animated = false,
}) {
  return (
    <img
      src={kaiImg}
      alt={alt}
      className={`kai-avatar-img${animated ? " kai-avatar-img--animated" : ""} ${className}`.trim()}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
